/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { login } from '../fn/user-controller/login';
import { Login$Params } from '../fn/user-controller/login';
import { registerUser } from '../fn/user-controller/register-user';
import { RegisterUser$Params } from '../fn/user-controller/register-user';
import { User } from '../models/user';
import { UserInfo } from '../models/user-info';
import { whoAmI } from '../fn/user-controller/who-am-i';
import { WhoAmI$Params } from '../fn/user-controller/who-am-i';

@Injectable({ providedIn: 'root' })
export class UserControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userControllerLogin()` */
  static readonly UserControllerLoginPath = '/users/login';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `login()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  login$Response(params: Login$Params, context?: HttpContext): Observable<StrictHttpResponse<({
'token': string;
} | {
'twoFactorRequired': boolean;
'pendingToken': string;
})>> {
    return login(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `login$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  login(params: Login$Params, context?: HttpContext): Observable<({
'token': string;
} | {
'twoFactorRequired': boolean;
'pendingToken': string;
})> {
    return this.login$Response(params, context).pipe(
      map((r: StrictHttpResponse<({
'token': string;
} | {
'twoFactorRequired': boolean;
'pendingToken': string;
})>): ({
'token': string;
} | {
'twoFactorRequired': boolean;
'pendingToken': string;
}) => r.body)
    );
  }

  /** Path part for operation `userControllerWhoAmI()` */
  static readonly UserControllerWhoAmIPath = '/users/my-profile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `whoAmI()` instead.
   *
   * This method doesn't expect any request body.
   */
  whoAmI$Response(params?: WhoAmI$Params, context?: HttpContext): Observable<StrictHttpResponse<UserInfo>> {
    return whoAmI(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `whoAmI$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  whoAmI(params?: WhoAmI$Params, context?: HttpContext): Observable<UserInfo> {
    return this.whoAmI$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserInfo>): UserInfo => r.body)
    );
  }

  /** Path part for operation `userControllerRegisterUser()` */
  static readonly UserControllerRegisterUserPath = '/users/register';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registerUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registerUser$Response(params?: RegisterUser$Params, context?: HttpContext): Observable<StrictHttpResponse<User>> {
    return registerUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registerUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registerUser(params?: RegisterUser$Params, context?: HttpContext): Observable<User> {
    return this.registerUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<User>): User => r.body)
    );
  }

}
